import { styled } from "@mui/material/styles";

export const BSPH2 = styled("h2")`
  font-family: "Inter", var(--bigspring-primary-font);
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: 0.0025em;
  margin: 0;
`;
